import React from 'react';
import { Close32 } from '@carbon/icons-react';
import { cardDetails } from '../../@types/AppConfiguration';
import MapLegend from '../Legend/Legend';
import '../../Card/Card.scss';
import './Card.scss';

const MapCard: React.FC<cardDetails> = ({
  cardInfo,
  legends,
  selectedLegendTypes,
  onUpdate,
  onClose,
}) => {
  const filterTypes = () => {
    const filteredArray: string[] = [];
    cardInfo.types.forEach((type: string) => {
      if (!filteredArray.includes(type)) {
        filteredArray.push(type);
      }
    });
    return filteredArray;
  };

  const filteredTypes = filterTypes();
  return (
    <div className="world-map-leadspace-widget__card world-map-leadspace-widget__card--map">
      <button
        onClick={onClose}
        className="world-map-leadspace-widget__card--close"
      >
        <Close32 />
      </button>
      <div className="world-map-leadspace-widget__card">
        <p className="world-map-leadspace-widget__card__title">
          {cardInfo.card.title}
        </p>
        <div className="world-map-leadspace-widget__card--top-segment">
          <div className="card_available">
            <h5 className="card_available-title">
              <b>Available</b>
            </h5>
            <div className="card_available-content">
              {filteredTypes.map((type: string) => {
                const filteredItems = cardInfo.entries.filter(
                  (entry: any) => entry.type === type,
                );
                let typeLabel = '';
                if (type === 'data-centers') {
                  typeLabel = 'Data Centers';
                } else if (type === 'federal-data-center') {
                  typeLabel = 'Federal Data Centers';
                } else if (type === 'network-pop') {
                  typeLabel = 'Network PoP';
                } else {
                  typeLabel = 'Multi-Zone Region';
                }

                return (
                  <p>
                    {typeLabel} -&nbsp;
                    {filteredItems.map((site: { siteCode: any }, i: number) => {
                      return (
                        <>
                          {i < filteredItems.length - 1 ? (
                            <span key={i}>{site.siteCode}, </span>
                          ) : (
                            <span key={i}>{site.siteCode}.</span>
                          )}
                        </>
                      );
                    })}
                  </p>
                );
              })}
            </div>
          </div>
        </div>
        <div className="world-map-leadspace-widget__card--bottom-segment">
          <MapLegend
            legends={legends}
            selectedLegendTypes={selectedLegendTypes}
            onUpdate={onUpdate}
          />
        </div>
      </div>
    </div>
  );
};

export default MapCard;
